import React, { useEffect,useState } from "react";
import Button from '../../../components/ACS-Dashboard/ACS-Blocks/Button';
import FilterButton from '../../../components/ACS-Dashboard/ACS-Blocks/FilterButton';
import Tabs from '../../../components/ACS-Dashboard/ACS-Blocks/Tabs';
import MyMessages from './TabContent/MyMessages';
import CustomerMessages from './TabContent/CustomerMessages';
import TemplatesMessages from './TabContent/TemplatesMessages';
import DraftsMessages from './TabContent/DraftsMessages';
import DeletedMessages from "./TabContent/DeletedMessages";
import NewMessage from './TabContent/NewMessage';
import { Search, Download } from "lucide-react";
import { useSelector, useDispatch } from 'react-redux';
import { selectModuleTabs } from '../../../redux/selectors/tabsSelectors'; // Correct import
import { addTab, removeTab, setActiveTab } from '../../../redux/slices/messagesSlice'; // Correct import

const MessageDetails = () => {
  const dispatch = useDispatch();
  const { tabs, activeTab, defaultTabsCount } = useSelector(selectModuleTabs("messages"));
  const [totalMessages, setTotalMessages] = useState(0);

  const defaultTabContents = {
    "my-messages": <MyMessages key="my-messages" setTotalMessages={setTotalMessages} />,
    "customer-messages": <CustomerMessages key="customer-messages" />,
    "templates": <TemplatesMessages key="templates" />,
    "drafts": <DraftsMessages key="drafts" />,
    "deleted-messages": <DeletedMessages key="deleted-messages" />,
  };

  const handleAddTab = () => {
    dispatch(addTab());
  };

  const handleRemoveTab = (index) => {
    if (index < defaultTabsCount) {
      alert("Default tabs cannot be removed.");
      return;
    }
    dispatch(removeTab({ tabIndex: index }));
  };

  return (
    <div className="p-fluid-1 shadow-md flex flex-col flex-1 h-full min-h-0 overflow-hidden">
    {/* Top Action/Filter Bar */}
    <div className="flex flex-wrap justify-between items-center rounded-md ml-[2] p-fluid-1">
      {/* Left side: Filter buttons, search box */}
      <div className="flex flex-wrap items-center gap-2">
      <FilterButton
          text="Filter"
          backgroundColor="white"
          textColor="black"
        />
        <FilterButton
          text="Custom Filters"
          backgroundColor="white"
          textColor="black"
        />
          <div className="relative flex items-center border border-gray-300 bg-white rounded-full px-3 py-1.5 w-80">
            <input
              type="text"
              placeholder="Search messages"
              className="w-full outline-none text-sm"
              aria-label="Search messages"
            />
           <button
            className="absolute right-3 text-gray-500 hover:text-gray-700"
          >
            <Search size={18} strokeWidth={2} />
          </button>
          </div>
          <span className="text-gray-500 text-fluid-sm">{totalMessages} messages</span>
        </div>

        <div className="flex items-center gap-2">
        <div className="p-2 rounded-md hover:bg-gray-100 transition cursor-pointer">
          <Download size={24} strokeWidth={2} className="text-[#223688]" />
        </div>
          <Button text="Create New Message" onClick={handleAddTab} aria-label="Create new message tab" />
        </div>
      </div>

      {/* Tab Content Area */}
    <div className="flex-1 min-h-0 flex flex-col scrollbar-hide">
        <Tabs
          tabs={tabs.map((tab) => tab.name)}
          tabContents={tabs.map((tab) =>
            defaultTabContents[tab.id] || (
              <NewMessage key={tab.id} title={tab.name} tabId={tab.id} isDynamic={tab.isDynamic} />
            )
          )}
          activeTab={activeTab}
          onTabChange={(index) => dispatch(setActiveTab({ index }))}
          isDeletable={tabs.map((_, index) => index >= defaultTabsCount)}
          onRemoveTab={handleRemoveTab}
          aria-label="Message tabs"
        />
      </div>
    </div>
  );
};

export default MessageDetails;